import React from "react";
import TableFilters from "@/components/ui/TableFilters";

const ReportConfig = ({ 
  filters = {}, 
  onFilterChange = () => {}, 
  filterType, 
  hasActiveFilters = false, 
  filteredCount = 0, 
  totalCount = 0, 
  onClearFilters = () => {}, 
  onDownloadCSV = null 
}) => (
  <>
    <TableFilters
      filters={filters}
      onFilterChange={onFilterChange}
      filterType={filterType}
    />
    
    {hasActiveFilters && (
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-blue-800 font-medium">
            Showing {filteredCount} of {totalCount} records
          </span>
          <div className="flex items-center space-x-2">
            {onDownloadCSV && (
              <button
                onClick={onDownloadCSV}
                className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              >
                Download CSV
              </button>
            )}
            {onClearFilters && (
              <button
                onClick={onClearFilters}
                className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Clear Filters
              </button>
            )}
          </div>
        </div>
      </div>
    )}
  </>
);

export default ReportConfig;
